import React from 'react';
import { CogIcon } from '@heroicons/react/24/outline';

const VesselEquipmentTab = ({ vessel, onVesselUpdate, user }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Equipment Management</h2>
      </div>
      
      <div className="text-center py-12">
        <CogIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">Equipment Management</h3>
        <p className="mt-1 text-sm text-gray-500">Track navigation equipment, electronics, and safety gear.</p>
        <div className="mt-6">
          <p className="text-sm text-gray-400">Coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default VesselEquipmentTab;
